import React, { useState, useEffect } from "react";
import "../../styles/componentsStyles/Browse/BookView.scss"
import HTMLFlipBook from "react-pageflip";
import { pdfjs, Document, Page as ReactPdfPage } from "react-pdf";

import samplePDF from '../../assets/files/web3.pdf'
import { MagnifyingGlass } from "react-loader-spinner";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// let width = 300;
// let height = 424;

const Page = React.forwardRef(({ pageNumber, width, key }, ref) => {
    return (
        <div key={key} ref={ref}>
            <ReactPdfPage pageNumber={pageNumber} width={width} />
        </div>
    );
});

function BookView() {
    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState({ width: 300, height: 424 });
    const [isDisplayLoader, setIsDisplayLoader] = useState(true);

    function onDocumentLoadSuccess({ numPages }) {
        setPageCount(numPages);
        setIsDisplayLoader(false);
    }

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 720) {
                // width = 300
                // height = 414
                setPageSize({ ...pageSize, width: 300, height: 424 })
            }

            if (window.innerWidth > 1024) {
                // width = 400
                // height = 524
                setPageSize({ ...pageSize, width: 400, height: 524 })
            }

            if (window.innerWidth > 1224) {
                // width = 400
                // height = 524
                setPageSize({ ...pageSize, width: 450, height: 574 })
            }

            if (window.innerWidth > 1480) {
                // width = 500
                // height = 624
                setPageSize({ ...pageSize, width: 500, height: 624 })
            }
            if (window.innerWidth > 1600) {
                // width = 500
                // height = 624
                setPageSize({ ...pageSize, width: 600, height: 724 })
            }
        };

        handleResize(); // Initial call to set dimensions based on screen size
        window.addEventListener('resize', handleResize); // Event listener for window resize

        return () => {
            window.removeEventListener('resize', handleResize); // Cleanup on unmount
        };
    }, [window.innerWidth]);

    // const handleZoomIn = (e) => {
    //     setPageSize({ width: pageSize.width + 20, height: pageSize.height + 20 })
    //     console.log(pageSize.width, pageSize.height);
    // };

    // const handleZoomOut = (e) => {
    //     setPageSize({ width: pageSize.width - 20, height: pageSize.height - 20 })
    // };

    return (
        <div className="book-view">

            {
                isDisplayLoader && <div className="book-view__loader-container">
                    <MagnifyingGlass
                        visible={true}
                        height="80"
                        width="80"
                        ariaLabel="magnifying-glass-loading"
                        wrapperStyle={{}}
                        wrapperClass="magnifying-glass-wrapper"
                        glassColor="#c0efff"
                        color="#e15b64"
                    />
                    <p>Loading...</p>
                </div>
            }
            <Document loading="" file={samplePDF} onLoadSuccess={onDocumentLoadSuccess} className="book-view__file">
                <HTMLFlipBook width={pageSize.width} height={pageSize.height} showCover={true} usePortrait={false} drawShadow={true} autoSize={true} >
                    {
                        Array.from({ length: pageCount }, (_, index) => (
                            <Page pageNumber={index + 1} width={pageSize.width} key={index} />
                        ))
                    }
                </HTMLFlipBook>
            </Document>

            {/* <div className="book-view__page-zoom">
                <button onClick={handleZoomIn} className='full-screen-view__action-btn'><span class="material-symbols-outlined">
                    add
                </span></button>
                <p className="full-screen-view__text">{Math.trunc(pageSize.width * 100)}%</p>
                <button onClick={handleZoomOut} className='full-screen-view__action-btn'><span class="material-symbols-outlined">
                    remove
                </span></button>
            </div> */}
        </div>
    );
}

export default BookView
